import { createSelector } from 'reselect';

export function getCurrentSiteUser(state) {
  return state.currentSiteUser;
}

export const getCurrentUserEmail = createSelector(
  getCurrentSiteUser,
  currentSiteUser => _.get(currentSiteUser, 'email', ''),
);



// WEBPACK FOOTER //
// ./src/widget/selectors/current-site-user.js